import {Form} from "../models/Form";

import {BasicStep} from "../models/steps/BasicStep";
import {ButtonStep} from "../models/steps/ButtonStep";
import {KeyboardStep} from "../models/steps/KeyboardStep";

import {Text} from "../models/fields/Text";
import {Textarea} from "../models/fields/Textarea";
import {Radio} from "../models/fields/Radio";
import {Select} from "../models/fields/Select";
import {Autocomplete} from "../models/fields/Autocomplete";
import {Button} from "../models/fields/Button";
import {Checkbox} from "../models/fields/Checkbox";
import {Datepicker} from "../models/fields/Datepicker";

import {MaskNumber} from "../models/fields/Features/mask/MaskNumber";
import {Mask} from "../models/fields/Features/mask/Mask";
import {MaskPattern} from "../models/fields/Features/mask/MaskPattern";

import {Option} from "../models/fields/Features/Option";

import store from '../store'

import ThanksRedirectStep from "../components/form/steps/library/fr/thanks_redirect/ThanksRedirectStep";
import HomeStep from "../components/form/steps/library/fr/mobile_home/HomeStep";
import GenderStep from "../components/form/steps/library/fr/gender/GenderStep";
import NameStep from "../components/form/steps/library/fr/name/NameStep";
import EmailStep from "../components/form/steps/library/fr/email/EmailStep";
import AddressStep from "../components/form/steps/library/fr/address/AddressStep";
import PhoneStep from "../components/form/steps/library/fr/phone_keyboard/PhoneStep";
import IbanStep from "../components/form/steps/library/fr/iban_optim_2023/IbanStep";
import PaymentOptinStep from "../components/form/steps/library/fr/payment_optin/PaymentOptinStep";
import SmsThanksStep from "../components/form/steps/library/fr/sms_thanks/SmsThanksStep";
import PaymentChoiceStep from "../components/form/steps/library/fr/payment_choice/PaymentChoiceStep";
import CreditCardStep from "../components/form/steps/library/fr/credit_card/CreditCardStep";
import CreditCardRedirectStep from "../components/form/steps/library/fr/credit_card_redirect/CreditCardRedirectStep";

import MobileFlux from "../views/fr_new_branding/MobileView";
import HomeView from "../views/fr_new_branding/HomeView";

let sms_service_status = window.sms_service_status==1 ? 'sms' : 'redirect_thanks';

export default new Form(MobileFlux)
    .firstStep('home')
    .apiEndpoint('/prospect')
    .addSteps({
        home: new BasicStep(HomeStep).nextStep('gender').parentComponent(HomeView),
        gender: new ButtonStep(GenderStep).nextStep('name')
            .beforeMount(() => {
                store.set('general_data/is_dirty', true)
            }).enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),
        name: new BasicStep(NameStep).nextStep('email')
            .button('Continuer').enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),
        email: new BasicStep(EmailStep).nextStep('address')
            .button('Continuer')
            .addFieldsToSend(['gender', 'lastname', 'firstname', 'email', 'optin_terms_conditions', 'optin_privacy'])
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),
        address: new BasicStep(AddressStep).nextStep('iban')
            .addFieldsToSend(['street', 'street_number', 'street_box_number', 'zip_code', 'city'])
            .button('Continuer').enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),
        // payment_choice: new ButtonStep(PaymentChoiceStep)
        //     .addFieldsToSend(['payment_type'])
        //     .guard(['iban','payment_type', 'optin_iban','codice_fiscale', 'phone', 'general_data/is_test'])
        //     .enterAnimateDuration(.2)
        //     .leaveAnimateDuration(.2),
        // credit_card: new BasicStep(CreditCardStep).nextStep('credit_card_redirect').button('Confermo')
        //     .enterAnimateDuration(.2)
        //     .leaveAnimateDuration(.2),
        // credit_card_redirect: new BasicStep(CreditCardRedirectStep).disableBackButton().last(),
        // iban: new BasicStep(IbanStep).nextStep('payment_optin').button('Confermo')
        //     .enterAnimateDuration(.2)
        //     .leaveAnimateDuration(.2)
        //     .beforeMount(()=>{
        //         if(!store.get('form_data/iban')){
        //             store.set('form_data/iban','BE')
        //         }
        //     })
        //     .addFieldsToSend(['iban']),
        iban: new KeyboardStep(IbanStep).nextStep('payment_optin').button('Confirmer')
            .guard(['iban', 'optin_iban', 'general_data/is_test'])
            .progressBarText(true)
            .beforeMount(() => {
                if (!store.get('form_data/iban')) {
                    store.set('form_data/iban', 'BE')
                }
            })
            .addFieldsToSend(['iban']).enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),
        payment_optin: new ButtonStep(PaymentOptinStep).nextStep('phone')
            .addFieldsToSend(['optin_iban']).enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),
        phone: new KeyboardStep(PhoneStep).nextStep(sms_service_status).button('Continuer')
            .beforeMount(() => {
                if (!store.get('form_data/phone') && store.get('form_data/iban') != store.get('func_data/test_iban')) {
                    store.set('form_data/phone', '+32')
                }
            })
            .addFieldsToSend(['phone'])
            .beforeLeave(() => {
                let match_token = store.get('general_data/match_token')
                let phone = store.get('form_data/phone')
                let form_token = store.get('general_data/form_token')
                let lang = store.get('general_data/lang')
                let country = store.get('general_data/country')
                let is_test = store.get('general_data/is_test')

                store.set('func_data/match_token', match_token);
                store.set('func_data/phone', phone);
                store.set('func_data/form_token', form_token);
                store.set('func_data/lang', lang);
                store.set('func_data/country', country);
                store.set('func_data/is_test', is_test);
                return axios.post('/send_sms_thanks',
                    {
                        phone,
                        match_token,
                        form_token,
                        lang,
                        country,
                        is_test
                    })
            }).enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),
        redirect_thanks: new BasicStep(ThanksRedirectStep).last().disableBackButton(),
        sms: new BasicStep(SmsThanksStep).last().disableBackButton().enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),

    });


